import angular from 'angular';
import checkBoxFilter from './checkBoxFilter';

export default angular
  .module('components.checkBoxFilter', [])
  .component('checkBoxFilter', checkBoxFilter).name;
